import { IIntegrationResponse, IntegrationType } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { Filter, toDataSourceResult } from 'utils/query_v3';

export type IntegrationsFilter = Readonly<{
    locationId: string;
    integrationType?: IntegrationType;
    active?: boolean;
    nameSearch?: string;
}>;

export type IntegrationsDataSourceOptions = BaseDataSourceOptions<
    IIntegrationResponse,
    IntegrationsFilter
>;
export type IntegrationsPagedDataSource = PagedDataSource<
    IIntegrationResponse,
    IntegrationsFilter
>;
export type IntegrationsInfiniteDataSource = InfiniteDataSource<
    IIntegrationResponse,
    IntegrationsFilter
>;

const getAllIntegrations: DataSourceQuery<IIntegrationResponse, IntegrationsFilter> = ({
    filter: { locationId, integrationType, active, nameSearch },
    page,
    pageLimit,
}) => {
    const filter = Filter.and(
        integrationType ? Filter.eq('IntegrationType', integrationType) : undefined,
        active ? Filter.eq('Active', active) : undefined,
        nameSearch ? Filter.contains('SoftwareName', nameSearch) : undefined,
        Filter.eq('IsDeleted', false),
    );

    return toDataSourceResult(
        sdClient.getIntegrationsForLocation({
            id: locationId,
            filter,
            page,
            pageLimit,
        }),
    );
};

export function usePagedIntegrationsDataSource(
    options: IntegrationsDataSourceOptions,
): IntegrationsPagedDataSource {
    return usePagedDataSource({
        ...options,
        query: getAllIntegrations,
    });
}

export function useInfiniteIntegrationsDataSource(
    options: IntegrationsDataSourceOptions,
): IntegrationsInfiniteDataSource {
    return useInfiniteDataSource({
        ...options,
        query: getAllIntegrations,
    });
}
